import React, { useEffect, useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { Person, Lock, ArrowRight } from 'react-bootstrap-icons';
import { getLogin, getUserInfoByTransactionAndOTPValid } from '../services';
import { properties } from '../utils/Properties_es';

const Login = ({ updateData }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  // Estados agrupados
  const [cedula, setCedula] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isVerifying, setIsVerifying] = useState(true);

  const mapResponseToForm = (data) => {
    if (!data) return {};
    return {
      typeId: String(data.identificationType || ""),
      name: `${data.firstName || ""} ${data.secondName || ""}`.trim(),
      lastName: data.lastName1 || "",
      secondLastName: data.lastName2 || "",
      identification: data.identification || "",
      nationality: data.citizenship || "",
      country: data.countryOfResidence || "",
      date: data.dateOfBirth || "",
      profession: data.proffesion ? String(data.proffesion) : "",
      occupation: data.occupation ? String(data.occupation) : "",
      civilStatus: data.maritalStatus || "",
      province: data.provincia ? String(data.provincia) : "",
      canton: data.county ? String(data.county) : "",
      distrito: data.district ? String(data.district) : "",
      barrio: data.neighborhood ? String(data.neighborhood) : "",
      address: data.addressLine1 || "",
      phone: String(data.phoneMobile || ""),
      phoneHome: String(data.phoneHome || ""),
      phoneWork: String(data.phoneOffice || ""),
      schooling: data.degreeLevel || "",
      email: data.eMail || ""
    };
  };

  const handleLoginSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;

    setError('');
    if (!cedula || !otpCode) {
      setError(properties.login_error_empty);
      return;
    }
    if (!id) {
      setError(properties.login_error_no_url_id);
      return;
    }

    setIsSubmitting(true);

    try {
      const token = await getLogin(otpCode,cedula,id);
      navigate(`/initial/${id}`);

    } catch (err) {
      console.error("Login Error:", err);
      if(err.status == 400){
        setError(properties.login_error_bad_request);    
      }else{
        setError(properties.login_error_invalid_otp);
      }
      
      
    } finally {
      setIsSubmitting(false); // Desactiva loading (pase lo que pase)
    }
  };
  useEffect(() => {
    
    if (id) {
      setIsVerifying(false);
    }
  }, [id, navigate, updateData]);
  
  if (isVerifying) {
    return (
      <div className="full-height-container d-flex align-items-center justify-content-center bg-primary-adel">
        <Spinner animation="border" variant="light" />
      </div>
    );
  }

  return (
    <div className="full-height-container bg-primary-adel d-flex align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={5} xl={4}>
            <Card className="shadow-lg border-0 p-4 bg-white rounded-4">
              <Card.Body>
                <h2 className="text-dark mb-1"><strong>{properties.login_brand}</strong></h2>
                <p className="text-muted small"><ArrowRight className="me-1" /> {properties.login_subtitle}</p>

                <p className="mt-4 mb-4 fw-bold">{properties.login_instruction}</p>

                {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}

                <Form onSubmit={handleLoginSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label className="small fw-bold"><Person className="me-1" /> {properties.login_id_label}</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={properties.login_id_placeholder}
                      value={cedula}
                      disabled={isSubmitting} // Deshabilitar mientras carga
                      onChange={(e) => setCedula(e.target.value)}
                      className="form-control-lg fs-6"
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="small fw-bold"><Lock className="me-1" /> {properties.login_otp_label}</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={properties.login_otp_placeholder}
                      maxLength={6}
                      value={otpCode}
                      disabled={isSubmitting} // Deshabilitar mientras carga
                      onChange={(e) => setOtpCode(e.target.value)}
                      className="form-control-lg fs-6 text-center ls-2"
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    size="lg"
                    className="w-100 py-2 shadow-sm rounded-3 d-flex align-items-center justify-content-center"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                        {properties.login_submitting}
                      </>
                    ) : (
                      properties.btn_login
                    )}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
